"use client";

import React from "react";

import { PublicCommerceHeader } from "@/features/public-site/components/PublicCommerceHeader";
import { PublicSiteFooter } from "@/features/public-site/components/PublicSiteFooter";

interface PublicAppShellProps {
  children: React.ReactNode;
  searchValue: string;
  onSearchChange: (value: string) => void;
}

export function PublicAppShell({
  children,
  searchValue,
  onSearchChange,
}: PublicAppShellProps) {
  return (
    <>
      <PublicCommerceHeader
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        searchPlaceholder="Search a product..."
      />
      <div>{children}</div>
      <PublicSiteFooter />
    </>
  );
}
